import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children }) => {
  const { user, loaded } = useSelector((state) => state.auth);
  if (!loaded) {
    return <div className="text-center mt-10">Checking authentication...</div>;
  }
  return user ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;